import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { imgUrl, track } from "@/lib/api";

// Villes dans un rayon d'environ 50 km autour d'Aix-en-Provence (SEO local)
const CITIES = [
  "Aix-en-Provence", "Ventabren", "Éguilles", "Puyricard", "Venelles", "Meyreuil",
  "Gardanne", "Bouc-Bel-Air", "Cabriès", "Simiane-Collongue", "Mimet", "Fuveau",
  "Peynier", "Rousset", "Trets", "Saint-Maximin-la-Sainte-Baume", "Peyrolles-en-Provence",
  "Le Puy-Sainte-Réparade", "Lambesc", "Rognes", "Saint-Cannat", "Vitrolles",
  "Rognac", "Berre-l'Étang", "Marignane", "Les Milles", "Vauvenargues", "Pertuis",
  "Salon-de-Provence", "Manosque", "Marseille", "Allauch", "Plan-de-Cuques",
  "La Bouilladisse", "Roquevaire", "Auriol", "Gréasque", "Châteauneuf-le-Rouge",
];

export default function Footer({ settings }) {
  const s = settings || {};
  const keywords = CITIES.map((c) => `Graphiste ${c}`);

  return (
    <footer data-testid="public-footer" className="relative z-10 border-t border-white/10 bg-zinc-950">
      {/* Marquee SEO local */}
      <div className="marquee-mask overflow-hidden border-b border-white/10 py-4 bg-yellow-400/5" data-testid="seo-marquee">
        <div className="marquee-track">
          {[...keywords, ...keywords].map((k, i) => (
            <span key={i} className="mx-6 text-sm font-medium text-zinc-400">
              <span className="text-yellow-400">✦</span> {k}
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          {s.logo_url && <img src={imgUrl(s.logo_url)} alt={s.studio_name} className="h-14 mb-4" />}
          <p className="text-zinc-400 text-sm leading-relaxed max-w-xs">{s.tagline}</p>
          <p className="text-zinc-500 text-xs mt-4 leading-relaxed">
            Graphiste freelance basé à Aix-en-Provence, j'accompagne les entreprises et collectivités
            dans toute la région Provence-Alpes-Côte d'Azur.
          </p>
        </div>
        <div>
          <h4 className="font-display text-yellow-400 mb-4 uppercase text-sm tracking-widest">Contact</h4>
          <div className="space-y-3 text-sm">
            <a data-testid="footer-phone" href={`tel:${s.phone}`} onClick={() => track("phone_click")} className="flex items-center gap-3 text-zinc-300 hover:text-yellow-400">
              <Phone size={16} /> {s.phone}
            </a>
            <a data-testid="footer-email" href={`mailto:${s.email}`} onClick={() => track("email_click")} className="flex items-center gap-3 text-zinc-300 hover:text-yellow-400">
              <Mail size={16} /> {s.email}
            </a>
            <div className="flex items-center gap-3 text-zinc-400">
              <MapPin size={16} /> {s.address}
            </div>
          </div>
        </div>
        <div>
          <h4 className="font-display text-yellow-400 mb-4 uppercase text-sm tracking-widest">Navigation</h4>
          <div className="flex flex-col gap-2 text-sm text-zinc-300">
            <Link to="/" className="hover:text-yellow-400">Accueil</Link>
            <Link to="/blog" className="hover:text-yellow-400">Blog</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} {s.studio_name || "Black Lemon Studio"} — Tous droits réservés.
      </div>
    </footer>
  );
}
